import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { Services } from "@/components/Services";
import { Chapters } from "@/components/Chapters";
import { Marquee } from "@/components/Marquee";
import { Fleet } from "@/components/Fleet";
import { CtaBand } from "@/components/CtaBand";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileCallBar } from "@/components/MobileCallBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain" />
      <Toaster theme="dark" position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Chapters />
        <Marquee />
        <Fleet />
        <CtaBand />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <div className="h-14 lg:hidden" />
      <MobileCallBar />
    </div>
  );
}

export default App;
